import React, { CSSProperties } from 'react';

type Props = {
  style?: CSSProperties;
  fill?: string;
  width?: string | number;
  className?: string;
  viewBox?: string;
};

const SVG: React.FC<Props> = ({
  style = {},
  fill = '#27FF00',
  width = '100%',
  className = '',
  viewBox = '0 0 110.5 98.196',
}) => (
  <svg
    width={width}
    style={style}
    height={width}
    viewBox={viewBox}
    xmlns="http://www.w3.org/2000/svg"
    className={`svg-icon ${className || ''}`}
    xmlnsXlink="http://www.w3.org/1999/xlink"
  >
    <g
      id="Grupo_2728"
      data-name="Grupo 2728"
      transform="translate(-118.767 -64.259) rotate(-11)"
    >
      <path
        fill={fill}
        id="Caminho_4774"
        data-name="Caminho 4774"
        d="M103.033,138.8a8.425,8.425,0,0,1-8.406-8.406V112.76a8.392,8.392,0,0,1,16.784,0v17.633A8.4,8.4,0,0,1,103.033,138.8Zm0-31.1a5.078,5.078,0,0,0-5.093,5.066v17.633a5.093,5.093,0,0,0,10.186,0V112.76A5.1,5.1,0,0,0,103.033,107.695Z"
        transform="translate(0 41.523)"
      />
      <path
        fill={fill}
        id="Caminho_4775"
        data-name="Caminho 4775"
        d="M106.214,138.8a8.425,8.425,0,0,1-8.406-8.406V112.76a8.392,8.392,0,0,1,16.784,0v17.633A8.42,8.42,0,0,1,106.214,138.8Zm0-31.1a5.077,5.077,0,0,0-5.093,5.066v17.633a5.079,5.079,0,1,0,10.158,0V112.76A5.072,5.072,0,0,0,106.214,107.695Z"
        transform="translate(83.916 41.523)"
      />
      <path
        fill={fill}
        id="Caminho_4776"
        data-name="Caminho 4776"
        d="M184.339,149.026a1.654,1.654,0,0,1-1.643-1.67c0-23.136-18.564-41.262-42.275-41.262-23.684,0-42.248,18.126-42.248,41.262a1.657,1.657,0,1,1-3.313,0c0-24.971,20.015-44.548,45.561-44.548s45.561,19.577,45.561,44.548A1.654,1.654,0,0,1,184.339,149.026Z"
        transform="translate(6.147 0)"
      />
      <path
        fill={fill}
        id="Caminho_4777"
        data-name="Caminho 4777"
        d="M123.016,113.146H98.675a1.643,1.643,0,1,1,0-3.285h24.341a2.78,2.78,0,0,0,2.519-2.683,1.657,1.657,0,0,1,3.313,0A6.068,6.068,0,0,1,123.016,113.146Z"
        transform="translate(63.445 71.913)"
      />
      <path
        fill={fill}
        id="Caminho_4778"
        data-name="Caminho 4778"
        d="M118,121.719H103.349a7.3,7.3,0,0,1-7.283-7.283v-1.7a7.3,7.3,0,0,1,7.283-7.283H118a7.28,7.28,0,0,1,7.283,7.283v1.7A7.28,7.28,0,0,1,118,121.719Zm-14.648-12.951a3.973,3.973,0,0,0-3.97,3.97v1.7a3.973,3.973,0,0,0,3.97,3.97H118a3.979,3.979,0,0,0,4-3.97v-1.7a3.979,3.979,0,0,0-4-3.97Z"
        transform="translate(37.961 69.829)"
      />
    </g>
  </svg>
);

export default SVG;
